import {checkPermission} from '../functions/permissions'

const ProtectedElement = (props) => (
  checkPermission(props.permission)
    ? props.children
    : null
)

export default ProtectedElement